import {excludedCountries, supportedCountries} from '../interfaces/countries';
import {Injectable} from '@angular/core';
import * as iso from 'iso-3166-2';
import {TranslateService} from '@ngx-translate/core';

export interface Country {
	name: string;
	code: string;
}

@Injectable({
	providedIn: 'root'
})
export class CountryStateService {

	constructor(
		private translateService: TranslateService
	) {}

	getSupportedCountries(): Country[] {
		let countries: Country[] = [];
		Object.keys(iso.data).forEach((code) => {
			if (excludedCountries.find(country => country.code === code)) {
				return;
			}
			countries.push({name: this.translateService.instant('countries.' + code), code})
		});
		return countries.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
	}

	getStatesOrProvincesByCountry(country: Country) {
		// console.log('Function: getStatesOrProvincesByCountry, : ');
		if (!country || typeof country === 'string') {
			return {states: null};
		}
		let currentCountry = supportedCountries
			.filter(item => item.code.toUpperCase() === country.code.toUpperCase() || item.country.toLowerCase() === country.name.toLowerCase())
			.shift();
		let result: string[];
		if (currentCountry && currentCountry.states) {
			result = [];
			currentCountry.states.forEach( state => {
				result.push(state.name);
			});
		}
		let isRequired = currentCountry ? currentCountry.required : false;
		let postalCode = currentCountry ? currentCountry.postalCode : true;
		return {states: result ? result.sort() : null, isRequired, postalCode};
	}

	getStatesOrProvincesAbbrByCountry(country: Country) {
		let result: object = {};
		if (!country) {
		  return {};
		}

		let countryObject = supportedCountries
			.filter(item => item.code.toUpperCase() === country.code.toUpperCase() || item.country.toLowerCase() === country.name.toLowerCase())
			.shift();
		if (countryObject && countryObject.states && countryObject.states.length > 0) {
			countryObject.states.forEach((state) => {
				result[state.abbreviation ? state.abbreviation : state.name] = state.name;
			});
		} else if (countryObject && countryObject.states && countryObject.states.length === 0) {
			return {provinceInput: true};
		}
		return result;
	}

	getCountryAbbr(country: string): string {
		let browserLang = this.translateService.getBrowserLang();
		if(browserLang == 'en'){
			const culturalLang = this.translateService.getBrowserCultureLang();
			browserLang = culturalLang.match(/en-GB/)? culturalLang : 'en';
		  }
		
		if (browserLang !== this.translateService.currentLang) {
			return Object.keys(iso.data)
				.find((key) => iso.data[key].name.toLowerCase() === country.toLowerCase());
		} else {
			return Object.keys(iso.data)
				.find((key) => this.translateService.instant('countries.' + key).toLowerCase() === country.toLowerCase());
		}
	}

	getCountryFromAbbr(abbr: string): Country {
		let country = abbr ? this.getSupportedCountries().find(item => item.code.toUpperCase() === abbr.toUpperCase()) : null;
		return country || null;
	}

	getCurrentState(countryAbbr:string, stateFromResponse: string) {
		let currentCountry = supportedCountries
			.find((record) => record.code === countryAbbr && record.states &&
				record.states
					.findIndex(state =>
						(state.name && state.name.toLowerCase() === stateFromResponse.toLowerCase()) ||
						(state.abbreviation && state.abbreviation.toLowerCase() === stateFromResponse.toLowerCase())
					) >= 0);
		if (!currentCountry) {
			return null;
		}
		let currentState = currentCountry.states.find(state =>
			state.name.toLowerCase() === stateFromResponse.toLowerCase() ||
			state.abbreviation.toLowerCase() === stateFromResponse.toLowerCase());
		return currentState ? currentState.name : null;
	}


}
